import { render } from "./OsBasedImageSelection.vue?vue&type=template&id=5708fb32&scoped=true"
import script from "./OsBasedImageSelection.vue?vue&type=script&lang=js"
export * from "./OsBasedImageSelection.vue?vue&type=script&lang=js"

import "./OsBasedImageSelection.vue?vue&type=style&index=0&id=5708fb32&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5708fb32"]])

export default __exports__